import { ComponentType } from 'react';
import lift from '@tcc/load-lifter';

type importFromS3Signature = (
  moduleName: string
) => Promise<{ default: ComponentType }>;

export const importFromS3: importFromS3Signature = (moduleName) =>
  new Promise((resolve) => lift([moduleName], (module) => resolve(module)));
